import { render, staticRenderFns } from "./ConsultDialog.vue?vue&type=template&id=6bc83b7c&scoped=true&"
import script from "./ConsultDialog.vue?vue&type=script&lang=js&"
export * from "./ConsultDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConsultDialog.vue?vue&type=style&index=0&id=6bc83b7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc83b7c",
  null
  
)

export default component.exports